<template>
  <div class="goods-box">
    <img :src="filePath+detail.picture"/>
    <div class="goods-content">
      <div class="text ellipsis_line2">
        {{detail.name}}
      </div>
      <div class="id">
        ID:{{detail.codes}}
<!--        <span class="ml10">品牌:{{detail.brandName}}</span>-->
        <span class="ml10">分类:{{detail.classifyName}}</span>
        <span class="ml10">销量：{{detail.totalSales}}</span>
      </div>
      <div class="flex">
        <el-tag class="tag" v-if="detail.goodsType===1">
          {{typeArr[detail.storeGoodsType]}}
        </el-tag>
        <el-tag class="tag" type="info" v-if="detail.applyStatus==0 && detail.goodsType==0">待审核</el-tag>

        <el-tooltip v-if="detail.applyStatus==2 && detail.goodsType==0" class="item" effect="dark" :content="detail.errorMsg" placement="top-start">
          <el-tag class="tag" type="danger">审核失败</el-tag>
        </el-tooltip>

        <el-tag class="tag" v-if="detail.isTop==1">推荐</el-tag>
        <el-tag class="tag" v-if="detail.isActivity > 0">推荐</el-tag>
        <el-tag class="tag" v-if="detail.isNews > 0">推荐</el-tag>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props:{
    detail:{
      type:Object,
      required:true
    }
  },
  name: "goods-box",
  data() {
    return {
      // 0出售 1租赁 2出售+租赁 2洗消
      typeArr:['出售','租赁','出售+租赁','洗消']
    }
  },
  mixins: [tableBase],
  methods: {},
  mounted() {

  }
}
</script>


<style lang="less" scoped>

.goods-box{
  display: flex;
  &+.goods-box{
    margin-top: 10px;
  }
  img{
    width: 60px;
    height: 60px;
  }
  .goods-content{
    flex: 1;
    margin-left: 10px;
    .id{
      display: flex;
      align-items: center;
      color: #9e9e9e;
      line-height: 18px;
    }
    .text{
      font-weight: bold;
      line-height: 18px;
    }
  }
}
.tag &+.tag{
  margin-left: 5px;
}
</style>
